import React, {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import './BannerBar.scss'
import SearchWidget from './SearchWidget';

const BannerBar: React.FC = () => {
  const location = useLocation();

  const randomLogoVariant = () => {
    return Math.floor(Math.random() * 12) + 1;
  };

  const logoVariantRef = useRef<number>(randomLogoVariant());
  const prevPathnameRef = useRef<string>(location.pathname);
  useEffect(() => {
    if (prevPathnameRef.current !== location.pathname) {
      logoVariantRef.current = randomLogoVariant();
      prevPathnameRef.current = location.pathname;
    }
  }, [location.pathname]);

  const logoVariant = logoVariantRef.current;

  const expandedPaths = [
    '/about',
    '/page/about',
    '/page/terms-of-service',
    '/page/privacy-policy'
  ];

  const isExpanded = expandedPaths.some(path =>
    location.pathname === path || location.pathname.startsWith(path + '/')
  );

  return (
    <section id="banner-section"
             className={`bg-gray-800 pb-12 ${!isExpanded ? 'banner-compacted' : ''} banner-${logoVariant} subpixel-antialiased`}>
      <div className="before"></div>
      <div className="container mx-auto px-4">
        <SearchWidget />
      </div>
    </section>
  );
};

export default BannerBar;
